import { useMutation, UseMutationResult, useQueryClient } from "@tanstack/react-query";
import { enum_api_uri } from "../utils/enum";
import axiosInstance from "./axiosInstance";

interface RequestQuery {
    category: string;
    list_no: string;
}

interface RequestBody {
    name: string;
    subject: string;
    contents: string;
    notice: number;
    b_file: File[];
}

export type updateRequest = RequestQuery & RequestBody;

export interface updateResponse {
    statusCode: number;
    message: string;
    data: {
        list_no: number;
    };
}

const createFormData = (data: RequestBody) => {
    const formData = new FormData();

    Object.keys(data).forEach(key => {
        let value = data[key as keyof RequestBody];

        if (key === "b_file" && Array.isArray(value)) {
            value.forEach(file => {
                formData.append("b_file", file);
            });
        } else if (value === null) {
            formData.append(key, "");
        } else {
            formData.append(key, value.toString());
        }
    });

    return formData;
};

export const usePutConsoleFaq = (
    successCallback?: (data: updateResponse) => void,
): UseMutationResult<updateResponse, Error, updateRequest, unknown> => {
    const queryClient = useQueryClient();
    const headers = {
        "Content-Type": "multipart/form-data",
    };

    return useMutation<updateResponse, Error, updateRequest>({
        mutationFn: async (registerData: updateRequest) => {
            const url = enum_api_uri.put_console_faq.replace(":category", registerData.category).replace(":list_no", registerData.list_no);
            const formData = createFormData({
                name: registerData.name,
                subject: registerData.subject,
                contents: registerData.contents,
                notice: registerData.notice,
                b_file: registerData.b_file,
            });
            const response = await axiosInstance.put(url, formData, { headers });
            return response.data;
        },
        onSuccess: data => {
            queryClient.invalidateQueries({ queryKey: ["useGetConsoleFaqDetail"] });
            successCallback?.(data);
        },
    });
};
